<template>
  <div class="newsListGroup">
    <ul>
      <li v-for="item in 3">
        <div class="newsListGroup-img newsListGroup-imgBg"></div>
        <div class="newsListGroup-box newsListGroup-boxBg">
          <h3></h3>
          <div class="newsListGroup-box newsListGroup-box newsListGroup-boxBg-dateRegion">
            <span></span>
            <span></span>
          </div>
          <p></p>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { Lazyload } from 'vant'
export default {
  props: {

    // isTab: {
    //   type: String,
    //   required: true
    // }
  },
  data () {
    return {
      url: this.$store.state.baseURL + '/',
      loadingShow: true
    }
  },
  mounted () {
    this.loadingShow = this.show
  }
}
</script>

<style lang="scss" scoped>
@import "../../static/stylebody.css";

.newsListGroup {
  margin-top: 28px;
  width: 100%;
  ul {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    li {
      width: calc(33.33% - 12px);
      margin-bottom: 30px;
      margin-left: 12px;
      &:nth-child(3n + 1) {
        margin-left: 0;
      }
    }
  }
  &-img {
    width: 100%;
    position: relative;
    .imgbg {
      display: none;
    }
    img {
      width: 100%;
      display: block;
    }
    em {
      position: absolute;
      top: 0;
      right: 0;
      z-index: 2;
      width: 50px;
      height: 50px;
      background: $color-1;
      &::after {
        content: "";
        display: block;
        position: absolute;
        top: 13px;
        left: 13px;
        z-index: 3;
        width: 25px;
        height: 25px;
        background: url("../images/icon-link.png") no-repeat;
        background-size: 100%;
        cursor: pointer;
      }
    }
  }
  &-imgBg {
    padding-top: 66.61%;
    background: #f8f8f8;
  }
  &-box {
    &-dateRegion {
      margin: 0 0 3px;
      span {
        display: block;
        font-size: 15px;
        color: $color-grey-2;
        line-height: 22px;
        letter-spacing: 0.5px;
        &:last-of-type {
          color: $color-grey-1;
          font-size: 15px;
          letter-spacing: 1px;
        }
      }
    }
    h3 {
      margin-top: 14px;
      margin-bottom: 1px;
      font-size: 24px;
      font-weight: 600;
      line-height: 40px;
      color: #272727;
    }
    p {
      height: 100px;
      font-size: 16px;
      font-weight: 300;
      line-height: 24px;
      color: #272727;

      display: -webkit-box;
      overflow: hidden;
      white-space: normal !important;
      text-overflow: ellipsis;
      word-wrap: break-word;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
    .details {
      display: flex;
      align-items: center;
      align-content: center;
      justify-content: flex-end;
      font-size: 14px;
      text-align: right;
      color: $color-1;

      i {
        font-style: normal;
        text-decoration: underline;
        margin-right: 4px;
      }
    }
    .mobileTime {
      display: none;
    }
  }
  &-boxBg {
    h3 {
      width: 100%;
      height: 32px;
      background: #efefef;
    }
    &-dateRegion {
      span {
        width: 40%;
        height: 16px;
        margin-bottom: 4px;
        background: #efefef;
        display: block;
      }
    }
    p {
      height: 72px;
      background: #efefef;
    }
  }
}

@media (max-width: 1600px) {
  .newsListGroup {
    margin-top: 24px;
    ul {
      li {
        width: calc(33.33% - 12px);
      }
    }
    &-box {
      &-dateRegion {
        span {
          font-size: 14px;
          line-height: 22px;
          &:last-of-type {
            font-size: 15px;
          }
        }
      }
      h3 {
        margin-top: 20px;
        font-size: 27px;
        line-height: 35px;
      }
      p {
        height: 72px;
        font-size: 14.5px;
        line-height: 23px;
      }
      .details {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 1440px) {
  .newsListGroup {
    margin-top: 22px;
    ul {
      li {
        width: calc(33.33% - 10px);
        margin-left: 10px;
        &:nth-child(3n + 1) {
          margin-left: 0;
        }
      }
    }
    &-box {
      &-dateRegion {
        margin: 0 0 3px;
        span {
          font-size: 13px;
          line-height: 22px;
          &:last-of-type {
            font-size: 14px;
          }
        }
      }
      h3 {
        margin-top: 18px;
        margin-bottom: 3px;
        font-size: 25px;
        line-height: 32px;
      }
      // p {
      //   height: 120px;
      //   font-size: 14.5px;
      //   line-height: 23px;
      // }
      .details {
        font-size: 12px;
      }
    }
  }
}

@media (max-width: 1000px) {
  .newsListGroup {
    &-box {
      &-dateRegion {
        margin: 0 0 3px;
      }
      h3 {
        margin-top: 16px;
        margin-bottom: 3px;
        font-size: 23px;
        line-height: 30px;
      }
      p {
        font-size: 13.5px;
      }
    }
  }
}

@media (max-width: 768px) {
  .newsListGroup {
    margin-top: 0;
    &-a {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 0;
    }
    ul {
      margin-top: 36px;
      flex-direction: column;
      li {
        display: inline-block;
        width: 100%;
        margin-left: 0;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
    &-img {
      width: 154px;
      height: 114px;
      .imgbg {
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: 50% 50%;
        display: block;
      }
      img {
        height: 100%;
        display: none;
      }

      em {
        display: none;
      }
    }
    &-box {
      width: calc(100% - 170px);
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 114px;
      &-dateRegion {
        display: none;
        margin: 0;
        margin-bottom: 4px;
        span {
          font-size: 12px;
          line-height: 16px;
          color: #74746e;
          &:last-of-type {
            font-size: 13px;
          }
        }
      }
      .mobileTime {
        display: block;
        color: #6d6e71;
      }
      h3 {
        margin-top: 4px;
        margin-bottom: 0;
        font-size: 20px;
        line-height: 23px;

        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      p {
        margin-top: 4px;
        height: 18px;
        line-height: 20px;
        color: #6d6e71;

        display: -webkit-box;
        overflow: hidden;
        white-space: normal !important;
        text-overflow: ellipsis;
        word-wrap: break-word;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .details {
        display: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NewsListBg.vue